import React from "react";
import { SERVICES } from "@/data/site";
import * as Icons from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-28 px-5 md:px-8 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Our Services"
          title="Everything you need for a seamless journey"
          subtitle="Twelve services under one roof — from tickets and stays to visas and airport transfers."
        />

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Reveal key={s.title} delay={i * 45}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group bg-white rounded-2xl p-5 md:p-6 border border-gray-100 hover:border-[#F9B233] shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-default h-full"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#EAF3FF] group-hover:bg-[#F9B233] flex items-center justify-center transition-colors">
                    <Icon className="w-6 h-6 text-[#0B3D91] group-hover:text-white transition-colors" strokeWidth={2} />
                  </div>
                  <h3 className="mt-4 text-sm md:text-base font-semibold text-[#222] tracking-tight leading-snug">{s.title}</h3>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
